(function ($) {
    $(document).ready(function () {
        var popupOpen = false;

        $('.famille-card.grid-element').on('click', function () {
            var data = $(this).html();
            $('.popup-famille .popup-content').html(data);
            $('body').addClass('popup-famille-open');
            $('.popup-famille').attr('aria-hidden', 'false').scrollTop(0);
            popupOpen = true;
            history.pushState({ famillePopup: true }, '', location.href);
        });

        function closePopup(viaPopstate) {
            if (!popupOpen) return;
            if (viaPopstate) $('.popup-famille').addClass('no-transition');
            $('body').removeClass('popup-famille-open');
            $('.popup-famille').attr('aria-hidden', 'true');
            popupOpen = false;
            if (viaPopstate) {
                requestAnimationFrame(function () {
                    requestAnimationFrame(function () {
                        $('.popup-famille').removeClass('no-transition');
                    });
                });
            } else {
                history.back();
            }
        }

        $(document).on('click', '.popup-close, .popup-retour', function () {
            closePopup(false);
        });

        $(document).on('keydown', function (e) {
            if (e.key === 'Escape') closePopup(false);
        });

        $(window).on('popstate', function () {
            closePopup(true);
        });
    });
})(jQuery);
